export const manifest = {
  screens: {
    scr_i2yazn: { name: "Home", route: "/" },
  },
}
